import authenticated from './http-clients/authenticated'

export default {
  index(params) {
    let url = `/tenants/${params.tenantID}/suggestions?paginate=true`

    if (typeof(params.active) !== 'undefined' && params.active !== null) {
      url = `${url}&active=${params.active}`
    }
    if (typeof(params.order) !== 'undefined' && params.order !== null) {
      url = `${url}&order=${params.order}`
    }
    if (typeof(params.desc) !== 'undefined' && params.desc !== null) {
      url = `${url}&desc=${params.desc}`
    }
    if (typeof(params.search) !== 'undefined' && params.search !== null) {
      url = `${url}&search=${params.search}`
    }
    if (typeof(params.page) !== 'undefined' && params.page !== null) {
      url = `${url}&page=${params.page}`
    }

    return authenticated({
      url,
      method: 'get'
    })
  },
  show({ tenantID, suggestionID }) {
    return authenticated({
      url: `/tenants/${tenantID}/suggestions/${suggestionID}`,
      method: 'get'
    })
  },
  update({ tenantID, suggestionID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/suggestions/${suggestionID}`,
      method: 'patch',
      data
    })
  },
  destroy({ tenantID, suggestionID }) {
    return authenticated({
      url: `/tenants/${tenantID}/suggestions/${suggestionID}`,
      method: 'delete'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/suggestions.js